import { QUERY_PARAMS } from 'consts/queryParams';

const isUnauthorizedUrl = (url = '') => {
  return url.includes(QUERY_PARAMS.resetPasswordToken);
};

export default isUnauthorizedUrl;
